import { Nullable } from '../../types/common'

class Button {
  element: Element
  text: Nullable<Element>

  constructor(element: Element) {
    this.element = element
    this.text = this.element.querySelector('[data-button-text]')
  }

  setDisable(isDisabled: boolean): void {
    this.element.toggleAttribute('disabled', isDisabled)
  }

  setLoading(isLoading: boolean): void {
    this.element.classList.toggle('loading', isLoading)
  }

  setText(text: string): void {
    if (!this.text) {
      return
    }

    this.text.textContent = text
  }
}

export default Button
